module.exports = __webpack_public_path__ + "img/报名记录.046234e3.png";